import { ResolveState } from 'wac-cli/src/common';

export class ErrorResult {
    filePath: string;
    type: string;
    message: string;
    position?: ErrorPosition;
    resolved: ResolveState;
}

export class ErrorPosition {
    line: number;
    character: number;
}
